import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Paginatable extends Vue {
  page = 1;
  totalPages = 1;
  perPage = 10;
}
